<script setup lang="ts">
import { AlignmentTypes } from '@/graphql/shared-types';

interface Props {
  text?: string;
  label?: string;
  typography?: string;
  alignment?: AlignmentTypes;
}

withDefaults(defineProps<Props>(), {
  text: '',
  typography: 'h1000',
  alignment: 'left',
});
</script>

<template>
  <div class="mb-8">
    <span :aria-label="$t('global.title')"></span>
    <p :aria-label="text" :class="[typography, `text-${alignment}`]">
      {{ text }}
    </p>
    <p
      v-if="label && label.trim().length > 0"
      class="text-charcoal b600"
      :aria-label="label"
      :class="[`text-${alignment}`]"
    >
      {{ label }}
    </p>
  </div>
</template>
